import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PromocionesService } from '../../services/promociones.service';
import { ValidatorAsyncCheckPromocion } from '../../promocion.validator';
import { DuplicatePromoDTO } from '../../modelos/Promocion';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { isDateAfter } from 'src/app/utils/validators';

@Component({
  selector: 'app-duplicar-promocion',
  templateUrl: './duplicar-promocion.component.html',
  styleUrls: ['./duplicar-promocion.component.css']
})
export class DuplicarPromocionComponent {

  @Input()
  idPromo: string;

  @Output()
  onSuccess = new EventEmitter<null>();

  form!: FormGroup;
  get idPromoField() {
    return this.form.get('idPromo');
  }
  get startDateField() {
    return this.form.get('fechaInicio');
  }
  get endDateField() {
    return this.form.get('fechaFin');
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.form = this.formBuilder.group({
      idPromo: ['', [Validators.required, Validators.maxLength(6), Validators.minLength(6)],
        [ValidatorAsyncCheckPromocion(this.promocionesService)]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
    }, {
      validators: isDateAfter
    })
  }

  acciones(event: string) {
    if (event === 'guardar') {
      this.duplicate();
    } else {
      document.getElementById('cerrarDuplicarModal').click();
    }
  }

  duplicate() {
    const body: DuplicatePromoDTO = {
      promoOrigen: this.idPromo,
      idPromo: this.idPromoField.value.toUpperCase(),
      fechaInicio: this.startDateField.value + "T00:00:00.873Z",
      fechaFin: this.endDateField.value + "T23:59:59.873Z"
    }
    this._util.confirmarSincronoPromesa({
      title: '¿Esta seguro de copiar la promoción?',
      text: `Nueva promoción ${body.idPromo}`,
      action: 'Copiar',
      funcion: this.promocionesService.duplicatePromo(body)
    }).then(() => {
      document.getElementById('cerrarDuplicarModal').click();
      this.onSuccess.emit();
    });
  }

}
